// extracted by mini-css-extract-plugin
module.exports = {"unsubscribedContact":"_3N7ZporO","icon":"_3fZTgAUG","tooltip":"_3ObFD_6W"};